module.exports = __webpack_public_path__ + "img/25.2e388aa5.png";